import React, { Component } from "react";
import { connect } from "react-redux";
import * as act from "../../actions";
import WordSearchFormRepeatable from "./Forms/WordSearchFormRepeatable.jsx";
import TypeWordCheckbox from "./Forms/TypeWordCheckbox.jsx";
import WordSearchResults from "./WordSearchResults";
import WordSearchResultsSimple from "./WordSearchResultsSimple";
import DamageCheckboxes from "./Forms/DamageCheckboxes.jsx";
//import * as FontAwesome from 'react-icons/lib/fa'
import {
  FormGroup,
  Checkbox,
  Radio,
  Form,
  Panel,
  InputGroup,
  Col,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

const list = [
  { value: "common_word", label: "Common word", selected: true },
  { value: "abbreviation", label: "Abbreviation", selected: true },
  { value: "logogram", label: "Logogram", selected: true },
  { value: "logogram:_monogram", label: "Logogram: monogram", selected: true },
  {
    value: "logogram:_syllabogram_used_as_logogram",
    label: "Logogram: syllabogram used as logogram",
    selected: true,
  },
  {
    value: "logogram:_specified",
    label: "Logogram: specified",
    selected: true,
  },
  {
    value: "logogram:_specified:_gender",
    label: "Logogram: specified: gender",
    selected: true,
  },
  {
    value: "logogram:_specified:_ligature:_logogram_+_syllabogram",
    label: "Logogram: specified: ligature: logogram + syllabogram",
    selected: true,
  },
  {
    value: "logogram:_ligature:_logogram_+_syllabogram",
    label: "Logogram: ligature: logogram + syllabogram",
    selected: true,
  },
  {
    value: "logogram:_ligature:_logogram_+_logogram",
    label: "Logogram: ligature: logogram + logogram",
    selected: true,
  },
  {
    value: "logogram:_ligature:_logogram_+_syllabogram_+_syllabogram",
    label: "Logogram: ligature: logogram + syllabogram + syllabogram",
    selected: true,
  },
  {
    value: "logogram:_ligature:_logogram_+_?",
    label: "Logogram: ligature: logogram + ?",
    selected: true,
  },
  { value: "measure_unit", label: "Measure unit", selected: true },
  { value: "number", label: "Numeral", selected: true },
  { value: "check_mark", label: "Check mark", selected: true },
  { value: "missing_signs", label: "Missing signs", selected: true },
  { value: "large_dot", label: "Large dot", selected: true },
  { value: "traces", label: "Traces", selected: true },
  { value: "word_divider", label: "Word divider", selected: true },
  { value: "dividing_line", label: "Dividing line", selected: true },
  { value: "seal", label: "Seal", selected: true },
  { value: "graffito", label: "Graffito", selected: true },
  { value: "blank_space", label: "Blank space (vacat)", selected: true },
  { value: "deest", label: "Deest", selected: true },
  { value: "narrow_line", label: "Narrow line", selected: true },
  { value: "quantum_satis", label: "Quantum satis", selected: true },
  { value: "question_mark", label: "Question mark", selected: true },
  { value: "break_at_left", label: "Break at left (])", selected: true },
  { value: "break_at_right", label: "Break at right ([)", selected: true },
  { value: "⟦", label: "Start of erased area (⟧)", selected: true },
  { value: "⟧", label: "Start of erased area at right (⟦)", selected: true },
];
class WordSearchForm extends Component {
  //  wordsearchAjax(e) {
  wordsearchAjax = (e) => {
    const { wordsearchsimple, wordsearchmultiple } = this.props;

    e.preventDefault();
    var serialize = require("form-serialize");
    var form = document.querySelector(`#${this.props.mode}`);
    var obj = serialize(form, { hash: true });
    if (this.props.mode === "multiple")
      wordsearchmultiple(
        { ...obj, format: this.props.mode },
        this.props.choosenElements
      );
    else
      wordsearchsimple(
        { ...obj, format: this.props.mode },
        this.props.choosenElements
      );
  };

  onReset(e) {
    const { wordsearchReset } = this.props;
    e.preventDefault();
    wordsearchReset();
  }

  render() {
    const {
      wordsearchdatasimple,
      wordsearchsimpleLoading,
      wordsearchdatamultiple,
      wordsearchmultipleLoading,
      wsReset,
    } = this.props;

    return (
      <div key={wsReset} className="well">
        <div className="row">
          <Form id={this.props.mode}>
            {/* Pass in minimum, maximum, and title for each repeating unit http://codepen.io/randseay/pen/ZbWyPJ */}
            <WordSearchFormRepeatable
              minRepeat={this.props.minRepeat}
              maxRepeat={this.props.maxRepeat}
              mode={this.props.mode}
              onReset={this.onReset.bind(this)}
              onSubmit={(e) => this.wordsearchAjax(e)}
              titleRepeat="Word"
            >
              <Panel>
                <FormGroup controlId="formHorizontalEmail">
                  <Col md={12}>
                    <Col md={3}>
                      <Checkbox name="normalized" defaultChecked inline>
                        Normalized
                      </Checkbox>{" "}
                      <Checkbox name="casesensitiv" defaultChecked inline>
                        Case sensitive
                      </Checkbox>{" "}
                    </Col>
                    <Col md={9}>
                      <Radio
                        name="typesearch"
                        value="exact"
                        defaultChecked
                        inline
                      >
                        Exact
                      </Radio>{" "}
                      <Radio name="typesearch" value="free_text" inline>
                        Free text
                      </Radio>{" "}
                      <Radio name="typesearch" value="from_start" inline>
                        From start
                      </Radio>{" "}
                      <Radio name="typesearch" value="from_end" inline>
                        From end
                      </Radio>{" "}
                      <Radio
                        name="typesearch"
                        value="regular_expression"
                        inline
                      >
                        Regular expression
                      </Radio>{" "}
                    </Col>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <InputGroup>
                    <InputGroup.Addon>Word </InputGroup.Addon>

                    <FormControl
                      type="text"
                      name="word"
                      placeholder="all words or specify here"
                    />
                  </InputGroup>
                </FormGroup>
                <div className="wordsearch_showhide">
                  <FormGroup>
                    <TypeWordCheckbox name="type" data={list} />
                  </FormGroup>

                  <DamageCheckboxes name="damaged" />

                  <FormGroup>
                    <Col md={4}>
                      <FormGroup>
                        <ControlLabel>Size</ControlLabel>
                        {/* phys_word.size .. skal hentes fra db */}
                        <FormControl
                          name="size"
                          componentClass="select"
                          placeholder="select"
                        >
                          <option value="select">select</option>
                          <option value="+1">+1</option>
                          <option value="0">Normal</option>
                          <option value="-1">-1</option>
                          <option value="-2">-2</option>
                          <option value="-3">-3</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <ControlLabel>Size previous</ControlLabel>
                        {/* phys_word.size_previous */}
                        <FormControl
                          name="size_previous"
                          componentClass="select"
                          placeholder="select"
                        >
                          <option value="select">select</option>
                          <option value="null">Same</option>
                          <option value="smaller">Smaller</option>
                          <option value="bigger">Bigger</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <ControlLabel>Size next</ControlLabel>
                        {/* phys_word.size_bigger */}
                        <FormControl
                          name="size_next"
                          componentClass="select"
                          placeholder="select"
                        >
                          <option value="select">select</option>
                          <option value="null">Same</option>
                          <option value="smaller">Smaller</option>
                          <option value="bigger">Bigger</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </FormGroup>

                  {/* phys_word */}
                  <FormGroup>
                    <Checkbox
                      name="reconstructed"
                      value="0"
                      defaultChecked
                      inline
                    >
                      Include non-reconstructed
                    </Checkbox>{" "}
                    <Checkbox
                      name="reconstructed"
                      value="1"
                      defaultChecked
                      inline
                    >
                      Include partly reconstructed
                    </Checkbox>{" "}
                    <Checkbox
                      name="reconstructed"
                      value="2"
                      defaultChecked
                      inline
                    >
                      Include entirely reconstructed
                    </Checkbox>{" "}
                  </FormGroup>

                  <FormGroup>
                    <Checkbox
                      name="uncertain_reading"
                      value="0"
                      defaultChecked
                      inline
                    >
                      Include certain readings
                    </Checkbox>{" "}
                    <Checkbox
                      name="uncertain_reading"
                      value="1"
                      defaultChecked
                      inline
                    >
                      Include partly uncertain readings
                    </Checkbox>{" "}
                    <Checkbox
                      name="uncertain_reading"
                      value="2"
                      defaultChecked
                      inline
                    >
                      Include uncertain readings
                    </Checkbox>{" "}
                  </FormGroup>

                  <FormGroup>
                    <Checkbox name="erased" value="0" defaultChecked inline>
                      Include non-erased
                    </Checkbox>{" "}
                    <Checkbox name="erased" value="1" defaultChecked inline>
                      Include partly erased
                    </Checkbox>{" "}
                    <Checkbox name="erased" value="2" defaultChecked inline>
                      Include entirely erased
                    </Checkbox>{" "}
                  </FormGroup>

                  <FormGroup>
                    <Col md={4}>
                      <FormGroup>
                        <ControlLabel>Position</ControlLabel>
                        {/* phys_word.position */}
                        <FormControl
                          name="position"
                          componentClass="select"
                          placeholder="select"
                        >
                          <option value="select">select</option>
                          <option value="0">Normal</option>
                          <option value="1">Superscript</option>
                          <option value="-1">Underscript</option>
                        </FormControl>
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <ControlLabel>Supra Sigillum</ControlLabel>
                        {/* phys_word.supra_sigillum */}
                        <FormControl
                          name="supra_sigillum"
                          componentClass="select"
                          placeholder="select"
                        >
                          <option value="select">select</option>
                          <option value="-1">Yes</option>
                          <option value="0">No</option>
                        </FormControl>
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <ControlLabel>Contains omitted signs</ControlLabel>
                        {/* phys_word.omission */}
                        <FormControl
                          name="omission"
                          componentClass="select"
                          placeholder="select"
                        >
                          <option value="select">select</option>
                          <option value="-1">Yes</option>
                          <option value="0">No</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </FormGroup>

                  <FormGroup>
                    <Col md={12}>
                      <ControlLabel>Line type</ControlLabel>
                      <FormControl
                        name="line_type"
                        componentClass="select"
                        placeholder="select"
                      >
                        <option value="select">select</option>
                        <option value="ruled">Ruled line (e.g. .1)</option>
                        <option value="unruled">Unruled line (e.g. .a)</option>
                        <option value="single line">Single line</option>
                        <option value="ruled: subdivision: ruling">
                          Ruled subdivision of ruled line (e.g. .1B)
                        </option>
                        <option value="ruled: subdivision: no ruling">
                          Unruled subdivision of ruled line (e.g. .1a)
                        </option>
                        <option value="single line: subdivision: ruling">
                          Ruled subdivision of single line (e.g .A)
                        </option>
                        <option value="single line: further_subdivision: no ruling">
                          Unruled further subdivision of single line (e.g. .Aa)
                        </option>
                        <option value="top_line">".0" line</option>
                      </FormControl>
                    </Col>
                  </FormGroup>
                </div>
              </Panel>
            </WordSearchFormRepeatable>
          </Form>

          {this.props.mode === "multiple" ? (
            <WordSearchResults
              isLoading={wordsearchmultipleLoading}
              mode={this.props.mode}
              results={wordsearchdatamultiple}
            />
          ) : (
            <WordSearchResultsSimple
              isLoading={wordsearchsimpleLoading}
              mode={this.props.mode}
              results={wordsearchdatasimple}
            />
          )}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    choosenElements: state.choosenElements,
    wordsearchdatasimple: state.wordsearchdatasimple,
    wordsearchdatamultiple: state.wordsearchdatamultiple,
    wordsearchsimpleLoading: state.wordsearchsimpleLoading,
    wordsearchmultipleLoading: state.wordsearchmultipleLoading,
    wsReset: state.wsReset,
  };
}
export default connect(mapStateToProps, act)(WordSearchForm);



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/WordSearchForm.js